import React from "react";
import { Box, Skeleton } from "@mui/material";

const ProgramMatrixSkeleton = () => {
  return (
    <Box>
      {/* Header */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              px={4}
              py={3}
              borderBottom={2}
              borderColor="grey.200"
            >
              <Box display="flex" alignItems="center" gap={2}>
                <Box
                  sx={{
                    width: "4px",
                    height: "20px",
                    bgcolor: "grey.300",
                  }}
                />
                <Skeleton variant="text" width={160} height={28} />
              </Box>
            </Box>
            <Box
      elevation={1}
      sx={{
        width: "100%",
        p: { xs: 2, sm: 2, md: 4, lg: 6, xl: 6 },
      }}
    >
      
      <Skeleton
        variant="rectangular"
        width="100%"
        height={220}
        sx={{
          borderRadius: 2,
          bgcolor: "grey.200",
        }}
      />
    </Box>

    </Box>
  );
};

export default ProgramMatrixSkeleton;
